export const FETCH_STARTED = 'FETCH_START@app';
export const FETCH_COMPLETED = 'FETCH_COMPLETED@app';
export const SET_CONTACT_INFO = 'SET_CONTACT_INFO@app';
export const SET_MESSAGE = 'SET_MESSAGE@app';
export const SET_FINGERPRINT = 'SET_FINGERPRINT@app';
